module.exports = __webpack_public_path__ + "media/images/sponsorLogo-c3af02583f5578dad6618685051a5cc8.png";